'use client';

import { useEffect, useState } from 'react';

import Icon from '@/components/ui/AppIcon';

export default function HeroSection() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center pt-32 pb-20 px-6 md:px-12 overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-secondary via-background to-background -z-10" />

      <div className="max-w-[1400px] mx-auto w-full">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Left Column - Text Content */}
          <div className="lg:col-span-7 reveal">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
              <span className="text-sm font-semibold text-muted-foreground uppercase tracking-wider">
                New Release 2026
              </span>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-foreground leading-tight tracking-tight mb-6">
              The Modern
              <br />
              <span className="gradient-text">Job Search Playbook</span>
            </h1>

            <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed mb-8 max-w-2xl">Written from an applicant's perspective not a hiring manager's. A practical guide to navigating today's fundamentally changed job market with real-world insights from someone who has been in the trenches of the modern job search.

            </p>

            {/* Key Features */}
            <div className="flex flex-wrap gap-4 mb-10">
              <div className="flex items-center gap-2 px-4 py-2 bg-card border border-border rounded-full">
                <Icon name="CheckCircleIcon" size={20} className="text-primary" />
                <span className="text-sm font-medium text-foreground">7 Practical Themes</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-card border border-border rounded-full">
                <Icon name="CheckCircleIcon" size={20} className="text-primary" />
                <span className="text-sm font-medium text-foreground">Applicant Strategy Insights</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-card border border-border rounded-full">
                <Icon name="CheckCircleIcon" size={20} className="text-primary" />
                <span className="text-sm font-medium text-foreground">All Career Stages</span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="https://www.amazon.com/Modern-Job-Search-Playbook-todayscompetitive-ebook/dp/B0G819181H/ref=sr_1_2?crid=2TSDI8KP39VR9&dib=eyJ2IjoiMSJ9.0PgYG1CoqmZnMKTQqxAQwqoUzkmQrMbTS1Rd92tof3PaMmxaQRfouVv7LwmQ9zvp85bAvBZWwqXDdOyVCy6CC_hdE_kyeUXJjHa8tVyosuUFyk1rm_IXwVNASZEH7gCeHOjbczgGOmxtMupMWnLEnSVIkdzJr-aOzi5_FCXuWkeJ7BhUXa8zk7pTF6ADRD3WFCSLA6jZHov6qbIRJowRJVteyJPCWosap6cG_0aSW5g.ioYhIbWhiJkcOx_S2rtDs1ZNblVYzug3KBsSL9RWqx4&dib_tag=se&keywords=the+modern+job+search+playbook&qid=1770750359&sprefix=the+modern+job+search+playbook%2Caps%2C139&sr=8-2"
                target="_blank"
                rel="noopener noreferrer">

                <button className="px-8 py-4 bg-[#FF9900] text-white rounded-full text-base font-bold hover:bg-[#FF9900]/90 hover:scale-105 active:scale-95 transition-all duration-300 shadow-xl shadow-[#FF9900]/30 flex items-center justify-center gap-2 w-full sm:w-auto">
                  <Icon name="ShoppingCartIcon" size={20} />
                  <span>Buy on Amazon</span>
                </button>
              </a>
              <a
                href="https://strategyshelf.mysamcart.com/checkout/the-modern-job-search-playbook"
                target="_blank"
                rel="noopener noreferrer">
                <button className="px-8 py-4 bg-[#1a56db] text-white rounded-full text-base font-bold hover:bg-[#1a56db]/90 hover:scale-105 active:scale-95 transition-all duration-300 shadow-xl shadow-[#1a56db]/30 flex items-center justify-center gap-2 w-full sm:w-auto">
                  <Icon name="ArrowDownTrayIcon" size={20} />
                  <span>Buy and Download Now</span>
                </button>
              </a>
            </div>
          </div>

          {/* Right Column - Book Cover with Floating Card */}
          <div className="lg:col-span-5 relative reveal" style={{ transitionDelay: '200ms' }}>
            {/* YouTube Video Embed */}
            <div className="relative w-full max-w-md mx-auto animate-cinematic">
              <div className="aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl border border-border">
                <iframe
                  src="https://www.youtube.com/embed/2K1nT10Gww0"
                  title="The Modern Job Search Playbook"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

}